"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuOrderItemBaseToJSON = exports.MenuOrderItemBaseFromJSONTyped = exports.MenuOrderItemBaseFromJSON = void 0;
var runtime_1 = require("../runtime");
function MenuOrderItemBaseFromJSON(json) {
    return MenuOrderItemBaseFromJSONTyped(json, false);
}
exports.MenuOrderItemBaseFromJSON = MenuOrderItemBaseFromJSON;
function MenuOrderItemBaseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'externalId': !(0, runtime_1.exists)(json, 'externalId') ? undefined : json['externalId'],
        'name': json['name'],
        'price': json['price'],
        'quantity': json['quantity'],
        'taxRate': json['taxRate'],
        'notes': !(0, runtime_1.exists)(json, 'notes') ? undefined : json['notes'],
    };
}
exports.MenuOrderItemBaseFromJSONTyped = MenuOrderItemBaseFromJSONTyped;
function MenuOrderItemBaseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'externalId': value.externalId,
        'name': value.name,
        'price': value.price,
        'quantity': value.quantity,
        'taxRate': value.taxRate,
        'notes': value.notes,
    };
}
exports.MenuOrderItemBaseToJSON = MenuOrderItemBaseToJSON;
